import { render, staticRenderFns } from "./CabeceraModal.vue?vue&type=template&id=1d2f1926&scoped=true&"
import script from "./CabeceraModal.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModal.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModal.vue?vue&type=style&index=0&id=1d2f1926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f1926",
  null
  
)

export default component.exports